import React, { memo } from "react";
import PropTypes from "prop-types";
import { Box, Image, Icon, Text } from "@chakra-ui/react";
import { FaLink } from "react-icons/fa";
import { getUrl } from "../../../_utils/url";

const wrapperStyles = {
  position: "relative",
  width: "full",
  height: "full",
  borderRadius: "lg",
  overflow: "hidden",
};

const imageStyles = {
  width: "full",
  height: "full",
  objectFit: "cover",
  border: 0,
};

const linkStyles = {
  alignItems: "center",
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "full",
  padding: 1,
  color: "blackAlpha.800",
  fontSize: "xs",
  lineHeight: "1.2em",
  backgroundImage: "linear-gradient(transparent, rgba(255, 255, 255, 0.9))",
};

const SimplePostLink = ({ link, image, isPast, urlShown }) => {
  if (!link) {
    return null;
  }

  const url = getUrl(link);

  return (
    <Box sx={wrapperStyles}>
      <Image
        src={image}
        fallback={<></>}
        sx={imageStyles}
        opacity={isPast ? "0.5" : "1"}
      />
      {urlShown && (
        <Text sx={linkStyles} isTruncated>
          <Icon
            as={FaLink}
            sx={{
              display: "inline-block",
              width: "1.25em",
              height: "1.25em",
              fontSize: "1em",
              verticalAlign: "middle",
              marginRight: "2px",
            }}
          />
          {url?.hostname || ""}
        </Text>
      )}
    </Box>
  );
};

SimplePostLink.propTypes = {
  link: PropTypes.string,
  image: PropTypes.string,
  isPast: PropTypes.bool,
  urlHidden: PropTypes.bool,
};

SimplePostLink.defaultProps = {
  link: undefined,
  image: undefined,
  isPast: false,
  urlShown: true,
};

export default memo(SimplePostLink);
